<template>
  <!-- H5登录页 -->
  <div class="mobileLogin">
    <div class="loginBox">
      <div class="logo">
        <img src="https://images.zhibo.tv/2020/0922/applogo@2x.png" alt="" />
      </div>
      <!-- 手机号 -->
      <div class="phoneBox">
        <input
          v-model="tel"
          type="text"
          name=""
          id=""
          placeholder="请输入手机号"
        />
      </div>
      <!-- 验证码 -->
      <div class="codeBox">
        <input
          v-model="code"
          type="text"
          name=""
          id=""
          placeholder="请输入验证码"
        />
        <div class="getCodeBtn" v-if="!cutdownIsShow" @click="getCode">
          {{ getCodeArgin ? '重发验证码' : '获取验证码' }}
        </div>
        <div class="getCodeBtn cutdown" v-if="cutdownIsShow">{{ btntxt }}</div>
      </div>
      <!-- 登录按钮 -->
      <div class="loginBtnBox">
        <div class="loginBtn" @click="gotoLogin">手机登录</div>
      </div>
      <!-- 协议 -->
      <div class="agreement">
        <div class="isAgree" v-if="isAgree" @click="changeAgree">
          <img
            src="https://images.zhibo.tv/2022/0318/icon_noagree.png"
            alt=""
          />
        </div>
        <div class="isAgree" v-if="!isAgree" @click="changeAgree">
          <img src="https://images.zhibo.tv/2022/0318/icon_agree.png" alt="" />
        </div>
        已阅读并同意<span @click="gotoAgreement(1)">《用户协议》</span
        ><span @click="gotoAgreement(2)">《隐私政策》</span>
        <div class="tips" v-if="tipsIsShow">
          <img src="https://images.zhibo.tv/2022/0318/bg_place.png" alt="" />
        </div>
      </div>

      <!-- 第三方登录 -->
      <div class="thirdLogin">
        <span>第三方快捷登录</span>
        <div class="thirdList">
          <div
            class="thirdItem"
            :class="{ isWX: !weiXin && index === 1 }"
            v-for="(item, index) in thirdList"
            :key="index"
            @click="handleThirdLogin(item.type)"
          >
            <img :src="item.icon_h" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'
import { Toast } from 'vant'
import axios from 'axios'
export default {
  name: '',
  data() {
    return {
      // 允许
      isAgree: true,
      tipsIsShow:false,
      // 手机号
      tel: '',
      // 验证码
      code: '',
      // 倒计时
      cutdownIsShow: false,
      time: 60,
      btntxt: '',
      // 第三方登录
      thirdList: [
        {
          icon: 'https://images.zhibo.tv/3x/icon_qq@3x.png',
          icon_h: 'https://images.zhibo.tv/3x/icon_qq_h@3x.png',
          name: 'qq',
          type: 4
        },
        {
          icon: 'https://images.zhibo.tv/3x/icon_weixin@3x.png',
          icon_h: 'https://images.zhibo.tv/3x/icon_weixin_h@3x.png',
          name: 'wechat',
          type: 3
        },
        // 微博去掉
        // {
        //   icon: 'https://images.zhibo.tv/3x/icon_weibo@3x.png',
        //   icon_h: 'https://images.zhibo.tv/3x/icon_weibo_h@3x.png',
        //   name: 'sina',
        //   type: 5
        // }
      ],
      token: '',
      roomNum: '',
      // 来源页
      from: '',
      getCodeArgin: false,
      weiXin: '',
      env: process.env.VUE_APP_BASE,
      thirdInfo: {
        test: {
          qq: '101997900',
          wx: 'wx1aa768ec91638a79',
          sina: '2041833082'
        },
        pre: {
          qq: '101997900',
          wx: 'wx5dc57154b4af07f0',
          sina: '2041833082'
        },
        online: {
          qq: '101240358',
          wx: 'wx5dc57154b4af07f0',
          sina: '650174257'
        }
      },
      nowThird: '',
    }
  },
  computed: {},
  watch: {},
  created() {
    if (this.env === '') {
      this.nowThird = this.thirdInfo.online
    } else if (this.env === 'p100-') {
      this.nowThird = this.thirdInfo.pre
    } else {
      this.nowThird = this.thirdInfo.test
    }
    // alert(document.cookie)
    // alert(this.$cookies.get('login_type'))
    this.isWeiXin()
    document.title = '登录'
    // 来源页（上一个页面地址）
    this.from = this.$route.query.from ? this.$route.query.from : ''
    console.log(this.from)
    this.$cookies.set('login_origin', this.from)
    this.getUserInfo()
  },
  methods: {
    // 判断是否是微信
    isWeiXin() {
      //ua判断移动端用的是不是特定类型的浏览器
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.weiXin = true
        return true // 是微信端
      } else {
        this.weiXin = false
        return false
      }
    },
    // 获取用户信息
    async getUserInfo() {
      axios.defaults.withCredentials = true
      let res = await this.$api.getUserInfo()
      console.log(res)
      if (res.data.status == 200) {
        console.log('获取用户信息')
        this.$cookies.set('token', res.data.data.userToken)
        this.$cookies.set('roomNum', res.data.data.roomNum)
        // alert(res.data.data.roomNum)
        // 能获取到用户信息，重定向到来源页
        if (this.from) {
          window.location.replace(this.from)
        }
      }
    },
    //获取验证码
    async getCode() {
      if (this.tel.length !== 11) {
        Toast('请输入正确的手机号格式')
      } else {
        let params = Qs.stringify({ phone: this.tel })
        let res = await this.$api.getCode(params)
        console.log(res)
        if (res.data.status == 200) {
          this.time = 60
          Toast('发送成功')
          this.timer()
          this.cutdownIsShow = true
        } else {
          Toast(res.data.data)
        }
      }
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.time--
        this.btntxt = this.time + 's后获取'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.cutdownIsShow = false
        this.getCodeArgin = true
      }
    },
    // 手机号+验证码登录
    async gotoLogin() {
      if (this.tel.length === 11 && this.code) {
        if (this.isAgree) {
          let params = Qs.stringify({ phone: this.tel, code: this.code })
          let res = await this.$api.phoneLogin(params)
          console.log(res)
          if (res.data.control.status == 200) {
            console.log('登录成功')
            this.token = res.data.data.token
            this.roomNum = res.data.data.room_num
            // 登录成功后把token和roomNum存入cookie
            this.$cookies.set('token', res.data.data.token)
            this.$cookies.set('roomNum', res.data.data.room_num)
            window.location.href = this.from
          } else {
            Toast(res.data.control.message)
          }
        } else {
          this.tipsIsShow = true
        }
      } else {
        Toast('请输入正确的手机号和验证码')
      }
    },
    changeAgree() {
      this.isAgree = !this.isAgree
      if (this.isAgree) {
        this.tipsIsShow = false
      }
    },
    // 跳转协议
    gotoAgreement(index) {
      if (index == 1) {
        window.open(
          'https://www.zhibo.tv/privacypolicy.html?tdsourcetag=s_pctim_aiomsg'
        )
      }
      if (index == 2) {
        window.open('https://static.zhibo.tv/agreement/privacy_agreement.html')
      }
    },
    // 处理第三方登录
    handleThirdLogin(type) {
      this.$cookies.set('login_terminal', 'H5', '1d')
      this.$cookies.set('login_type', type, '1d')
      // alert(type)
      // alert(this.$cookies.get('login_type'))
      // alert(document.cookie)
      this.$cookies.remove('isThirdNew')
      // this.$cookies.set('isThirdNew', '-1', '1d', null, 'zhibo.tv')
      // setTimeout(() => {
      // }, 1000);
      if (type == 4) {
        window.location.href =
        'https://' + this.env + 'www.zhibo.tv/index/ologin/login_source/' +
        window.location.href +
        '/login_type/qq/is_cpp//is_mobile/0/app_from/1?isRemeber=1&isJump=1'
      } else if (type == 3) {
        window.location.href =
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.nowThird.wx}&redirect_uri=https://${this.env}static.zhibo.tv/publicmodule/callback&response_type=code&scope=snsapi_userinfo&state=cDU5V2&connect_redirect=1#wechat_redirect`
      } else if (type == 5) {
        // 微博新回调（流程已通）
        // window.WB2.login()
        // https://api.weibo.com/2/oauth2/authorize?client_id=2041833082&response_type=token&display=js&transport=html5&referer=https://t100-static.zhibo.tv/publicmodule/pcheader
        window.location.href =
          `https://api.weibo.com/oauth2/authorize?client_id=${this.nowThird.sina}&response_type=code&redirect_uri=https://${this.env}static.zhibo.tv/publicmodule/callback`
      }
    }
  }
}
</script>

<style lang="less" scoped>
.mobileLogin {
  padding: 0 0.3rem;
  background: #fff;
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  .loginBox {
    padding-top: 0.7rem;
    .logo {
      width: 1.72rem;
      height: 1.92rem;
      margin: 0 auto;

      margin-bottom: 0.7rem;

      img {
        display: block;
        width: 1.72rem;
        height: 1.92rem;
      }
    }
    input::placeholder {
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.42rem;
    }
    .phoneBox {
      width: 100%;
      height: 1.12rem;
      border-bottom: 0.14vw solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: center;
      input {
        width: 100%;
        height: 1rem;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        line-height: 0.42rem;
      }
    }
    .codeBox {
      width: 100%;
      height: 1.12rem;
      border-bottom: 0.14vw solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: space-between;
      input {
        height: 1rem;
        font-size: 0.3rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333;
        line-height: 0.42rem;
      }
      .getCodeBtn {
        width: 1.95rem;
        height: 0.62rem;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #e9001d;
        position: relative;
        &:after{
          content:'';
          position:absolute;
          left:0; 
          top:0;
          width:100%;
          height:100%;
          border:2px solid #e9001d;
          box-sizing:border-box;
          transform-origin: 0 0;
          border-radius: 3rem;
          overflow: hidden;
        }
      }
      .cutdown {
        background: #f8f9fa;
        color: #333333;
        border: 0.14vw solid #f8f9fa;
      }
    }
    .loginBtnBox {
      width: 100%;
      height: 1.12rem;
      margin-top: 0.4rem;
      margin-bottom: 0.3rem;
      background: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      .loginBtn {
        width: 6.9rem;
        height: 0.88rem;
        border-radius: 0.5rem;
        background: #e9001d;
        display: flex;
        justify-content: center;
        align-items: center;

        font-size: 0.32rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
    }
    .agreement {
      margin-bottom: 2.6rem;
      text-align: center;
      font-size: 0.28rem;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: #999999;
      line-height: 0.54rem;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      .isAgree {
        display: inline-block;
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 0.1rem;
        img {
          display: block;
          width: 0.32rem;
          height: 0.32rem;
        }
      }
      span {
        color: #e9001d;
      }
      .tips {
        width: 3.56rem;
        height: 0.82rem;
        position: absolute;
        bottom: -150%;
        left: 4%;

        img {
          display: block;
          width: 3.56rem;
          height: 0.82rem;
        }
      }
    }
    .thirdLogin {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 0.24rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .thirdList {
        // width: 5.8rem;
        margin-top: 0.2rem;
        display: flex;
        justify-content: center;
        .thirdItem {
          width: 2.3rem;
          height: 1.2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            display: block;
            width: 0.8rem;
            height: 0.8rem;
          }
        }
        .isWX {
          display: none;
        }
      }
    }
  }
}
@media (-webkit-min-device-pixel-ratio : 1.5) and (-webkit-max-device-pixel-ratio : 2.5){
  .mobileLogin .loginBox .codeBox .getCodeBtn::after{
    width:200%; height:200%; transform: scale(.5);
  }
    
}
@media (-webkit-min-device-pixel-ratio : 2.5) {
    .mobileLogin .loginBox .codeBox .getCodeBtn::after{
    width:300%; height:300%; transform: scale(.3333);
  }
}
</style>
